import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef, ElementRef } from 'react';
import { OwcModalDialog } from '@one/react';

export type PocModalDialogProps = ComponentPropsWithoutRef<typeof OwcModalDialog>;

export const PocModalDialog = forwardRef<ElementRef<typeof OwcModalDialog>, PocModalDialogProps>((props, ref) => (
    <OwcModalDialog ref={ref} {...props} />
));

PocModalDialog.displayName = 'PocModalDialog';
